import {
  SET_CUSTOMERS1,
  SET_CUSTOMERS2
} from '@/store/mutation-types'
import service from '@/service'
import isEmpty from 'lodash/isEmpty'

const createCustomer = customer => ({
  name: {
    pl: customer.name,
    en: customer.name_en
  },
  link: customer.link
})

const localizeCustomer = lang => customer => ({
  ...customer,
  name: customer.name[lang]
})

const state = {
  customers: [],
  customers2: []
}

const getters = {
  customers (state, getters, { i18n }) {
    const localize = localizeCustomer(i18n.locale)
    return state.customers.map(localize)
  },
  customers2 (state, getters, { i18n }) {
    const localize = localizeCustomer(i18n.locale)
    return state.customers2.map(localize)
  }
}

const mutations = {
  [SET_CUSTOMERS1] (state, customers = []) {
    state.customers = customers.map(createCustomer)
  },
  [SET_CUSTOMERS2] (state, customers2 = []) {
    state.customers2 = customers2.map(createCustomer)
  }
}

const actions = {
  fetchCustomers ({ state, commit }) {
    if (!isEmpty(state.customers)) return Promise.resolve()
    return service.about.customers().then((res = {}) => {
      commit(SET_CUSTOMERS1, res.customers)
    })
  },
  fetchCustomers2 ({ state, commit }) {
    if (!isEmpty(state.customers2)) return Promise.resolve()
    return service.about.customers1().then((res = {}) => {
      commit(SET_CUSTOMERS2, res.customers)
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/about.js